var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-layout w-full h-screen flex items-center justify-center"},[_c('div',[_c('icon',{attrs:{"name":"TypingDots"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }